var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 67,
    viewBox: "0 0 72 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_199_1441",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 67
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 67,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_199_1441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3063 23.513C43.6485 20.8522 40.4369 19.5207 36.6703 19.5207C32.9022 19.5207 29.6906 20.8522 27.0323 23.513C24.374 26.1728 23.0466 29.3718 23.0466 33.1062C23.0466 36.8931 24.374 40.1298 27.0323 42.8161C29.6906 45.5029 32.9022 46.8451 36.6703 46.8451C40.4369 46.8451 43.6485 45.5029 46.3063 42.8161C48.9646 40.1298 50.2935 36.8931 50.2935 33.1062C50.2935 29.3718 48.9646 26.1728 46.3063 23.513ZM51.3742 47.4626C47.3091 51.4768 42.3935 53.4834 36.6311 53.4834C30.9196 53.4834 26.0305 51.4768 21.9654 47.4626C17.8997 43.4489 15.8677 38.6129 15.8677 32.9513C15.8677 27.3937 17.8997 22.66 21.9654 18.7488C26.0305 14.8391 30.9196 12.8824 36.6311 12.8824C42.3935 12.8824 47.3091 14.8391 51.3742 18.7488C55.4389 22.66 57.4725 27.3937 57.4725 32.9513C57.4725 38.6129 55.4389 43.4489 51.3742 47.4626Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8595 42.5254L41.3763 31.639H37.7478L38.7843 24.1217L32.5632 34.4899H35.9328L33.8595 42.5254Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1177 1.05287H38.0055V9.08838H34.1177V1.05287Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8159 31.1205H68.8514V35.0088H60.8159V31.1205Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1136 6.96842L21.4807 5.02451L25.4985 11.9828L22.1314 13.9268L18.1136 6.96842Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3328 6.3505L51.0248 4.42799L47.0779 11.3104L50.3858 13.2329L54.3328 6.3505Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1977 18.6046L63.2941 15.2849L56.4341 19.2721L58.3377 22.5918L65.1977 18.6046Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0764 57.0412H37.9642V65.0767H34.0764V57.0412Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0485 59.16L21.4201 61.1039L25.4425 54.1455L22.0713 52.2016L18.0485 59.16Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3163 59.7791L51.0038 61.7017L47.0518 54.8198L50.3638 52.8967L54.3163 59.7791Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1912 47.525L63.2855 50.8452L56.4169 46.8575L58.3231 43.5378L65.1912 47.525Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0355 31.1205H4.00002V35.0088H12.0355V31.1205Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65358 18.6046L9.55724 15.2849L16.4172 19.2721L14.5136 22.5918L7.65358 18.6046Z",
    fill: "#86BE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66022 47.525L9.56591 50.8452L16.4346 46.8575L14.5284 43.5378L7.66022 47.525Z",
    fill: "#86BE88"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.615c1fd0345f54eb4eec4bdd9233306b.svg";
export { ForwardRef as ReactComponent };